import React, { useState } from 'react';
import { Save } from 'lucide-react';
import { apiCall, useAdminData, StringListEditor } from './_helpers';

const ChefsTableManager = ({ onMessage }) => {
  const [data, setData, refetch] = useAdminData('chefs-table', {});
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try { await apiCall('PUT', 'chefs-table', data); onMessage('success', 'Saved'); refetch(); }
    catch (e) { onMessage('error', e.message); }
    finally { setSaving(false); }
  };

  const fields = [
    ['title', 'Title'], ['subtitle', 'Subtitle'],
    ['duration', 'Duration'], ['party_size', 'Party Size'],
    ['availability', 'Availability'], ['reservation_notice', 'Reservation Notice'],
  ];

  return (
    <div className="bg-white rounded-xl p-6 shadow-md">
      <h2 className="text-2xl font-bold mb-6">Chef's Table (Homepage Section)</h2>
      <p className="text-sm text-gray-500 mb-6">For the full /chefs-table page content, edit it under Pages → Chef's Table.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {fields.map(([k, label]) => (
          <div key={k}>
            <label className="block text-sm font-medium mb-2">{label}</label>
            <input type="text" value={data[k] || ''} onChange={(e) => setData({ ...data, [k]: e.target.value })} className="w-full border rounded-lg px-4 py-2" />
          </div>
        ))}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium mb-2">Description</label>
          <textarea value={data.description || ''} onChange={(e) => setData({ ...data, description: e.target.value })} className="w-full border rounded-lg px-4 py-2" rows={3} />
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm font-medium mb-2">Features</label>
          <StringListEditor items={data.features || []} onChange={(items) => setData({ ...data, features: items })} placeholder="Feature text" />
        </div>
      </div>
      <button onClick={save} disabled={saving} className="mt-6 bg-[#C9A86C] text-white px-6 py-2 rounded-lg flex items-center gap-2 hover:bg-[#B8956A] disabled:opacity-50">
        <Save size={18} /> {saving ? 'Saving…' : 'Save Changes'}
      </button>
    </div>
  );
};

export default ChefsTableManager;
